import React, { useState, useEffect } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  Autocomplete,
  Grid,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Popper,
  Modal,
  CircularProgress,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { PrescriptionForm } from "../../../utils/constant";
import CloseIcon from "@mui/icons-material/Close";
import {
  mailBtn,
  primaryBtnTeal,
  textfieldTextPrep,
} from "../../../style/PatientDetailsStyle";
import UseFetchOptions from "../../../helper/UseFetchOptions";
import { menuItemStyle, primaryBtn } from "../../../style/AppointmentStyle";
import UseFetchDoctorList from "../../../helper/UseFetchDoctorList";
import UseFetchVisitType from "../../../helper/UseFetchVisitType";
import UseFetchReferDoctor from "../../../helper/UseFetchReferDoctor";
import {
  removeInvestigation,
  updateMasterData,
} from "../../../connections/putApi";
import { showToast } from "../../../utils/toastUtil";
import {
  addOptionInAppointForm,
  ExtractMedicineSummaryV1,
} from "../../../connections/postApi";
import { useDispatch, useSelector } from "react-redux";
import { createPatient } from "../../../connections/postApi";
import { saveOldPatientAppointment } from "../../../connections/putApi";
import CustomModal from "../../CustomModal/CustomModal";
import PatientMedicalReports from "../../ModalChildren/PatientMedicalReports";
import ReferrerEmail from "../../ModalChildren/ReferrerEmail";
import { setDoctorOption } from "../../../redux/slices/prescriptionSlice";
import {
  getMailTemplate,
  getPatientAiSummary,
} from "../../../connections/getApi";
import Referrer from "../../ModalChildren/Referrer";
import SearchIcon from "@mui/icons-material/Search";
import {
  setPrescriptionData,
  setSearchPatient,
  setPatientDetailsData,
  setAppointmentData,
} from "../../../redux/slices/prescriptionSlice";
import useDebounce from "../../../hooks/UseDebounce";
import UseSearchPatient from "../../../helper/UseSearchPatient";
import UsePatientDetail from "../../../helper/UsePatientDetail";
import UseFetchAppointmentDetailsPatient from "../../../helper/UseFetchAppointmentDetailsPatient";
import UsePatientDetailPrescription from "../../../helper/UsePatientDetailPrescription";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import SchoolIcon from "@mui/icons-material/School";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import { keyframes } from "@emotion/react";
import loadingSpinner from "../../../assets/loadingSpinner.svg";
import UseFetchInvestigationList from "../../../helper/UseFetchInvestigationList";
import { useTour } from "@reactour/tour";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PatientRecords from "../../ModalChildren/PatientRecords";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContentPasteGoOutlinedIcon from "@mui/icons-material/ContentPasteGoOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { AudioRecorder } from "react-audio-voice-recorder";
import { uploadFileToS3 } from "../../../connections/s3Upload";
import SOAP from "../../ModalChildren/SOAP";
import UseFetchAiSummaryS3 from "../../../helper/UseFetchAiSummaryS3";
import PatientHistorySummary from "../../ModalChildren/PatientHistorySummary";
dayjs.extend(utc);
dayjs.extend(timezone);

const rotateSpinner = keyframes`
 0% { transform: rotate(0deg); }
 10% { transform: rotate(36deg); }
 20% { transform: rotate(72deg); }
 30% { transform: rotate(108deg); }
 40% { transform: rotate(144deg); }
 50% { transform: rotate(180deg); }
 60% { transform: rotate(216deg); }
 70% { transform: rotate(252deg); }
 80% { transform: rotate(288deg); }
 90% { transform: rotate(324deg); }
 100% { transform: rotate(360deg); }
`;

const PatientInfoForm = ({ setCommonData, errors, setErrors }) => {
  const { currentStep, isOpen, setCurrentStep } = useTour();
  const [allFormFields, setAllFormFields] = useState(PrescriptionForm);
  const [formState, setFormState] = useState({});
  const [fieldOptions, setFieldOptions] = useState({});
  const [openDialogs, setOpenDialogs] = useState({});
  const [dialogInput, setDialogInput] = useState("");
  const [editingOption, setEditingOption] = useState(null);
  const [investigations, setInvestigations] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openReferrerEmail, setOpenReferrerEmail] = useState(false);
  const [openRefModal, setRefModal] = useState(false);
  const [drReferrerDetail, setDrReferrerDetail] = useState(false);
  const [mailTemplate, setMailTemplate] = useState(null);
  const [openSearchDropDown, setOpenSearchDropDown] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [patientId, setPatientId] = useState(null);
  const [searchData, setSearchData] = useState({
    q: "",
    page: 1,
    perPage: 10,
  });
  const [appointmentId, setAppointmentId] = useState(null);
  const [prescriptionId, setPrescriptionId] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [appointmentsDate, setAppointmentsDate] = useState([]);
  const [drConsultId, setDrConsultId] = useState("");
  const [patientRecordsModal, setPatientRecordsModal] = useState(false);

  //showing data in mount phase
  const patientDetailsData = useSelector(
    (state) => state.prescription.patientDetailsData,
  );
  const appointmentData = useSelector(
    (state) => state.prescription.appointmentData,
  );
  // const isLoading = useSelector((state) => state.prescription.isLoading);

  const dispatch = useDispatch();
  const handlePreview = () => {
    if (!patientDetailsData.id) {
      showToast(" Please select a patient first ", "ERROR");
      return null;
    }
    setOpenModal(true);
  };

  const handleReferrerEmail = () => {
    if (!patientDetailsData.id) {
      showToast("Please select a patient first ", "ERROR");
      return null;
    }
    if (!drReferrerDetail) {
      showToast("Please select a doctor to refer first", "ERROR");
      return null;
    }
    setOpenReferrerEmail(true);
  };

  const handlePatientRecordsModal = () => {
    if (!patientDetailsData.id) {
      showToast("Please select a patient first ", "ERROR");
      return null;
    }
    setPatientRecordsModal(true);
  };

  const handleRefModal = () => {
    setRefModal(true);
  };

  const handleSelectCabinEntry = (id) => {
    const now = dayjs().tz("Asia/Kolkata").toISOString();
    // ISO format: you can customize it

    let entries = JSON.parse(localStorage.getItem("cabinEntries")) || [];
    // Check if already exists
    if (entries?.id) {
      const newEntry = { id: id, entryTime: entries?.entryTime };
      localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
      // setCabinEntries(entries);
    } else {
      const newEntry = { id: id, entryTime: now };
      localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
      // setCabinEntries(entries);
    }

    // const now = new Date().toISOString(); // ISO format: you can customize it
    // // Get previous entries from localStorage
    // let entries = JSON.parse(localStorage.getItem("cabinEntries")) || [];
    // // Check if already exists
    // const alreadyExists = entries.some((entry) => entry?.id === id);
    // if (!alreadyExists) {
    //   entries.push({ id: id, entryTime: now });
    //   // Update localStorage
    //   localStorage.setItem("cabinEntries", JSON.stringify(entries));
    //   // Optional: also update local state

    // }
  };

  useEffect(() => {
    if (patientDetailsData) {
      handleSelectCabinEntry(patientDetailsData?.id);
      setFormState({
        id: patientDetailsData?.uid,
        fullName: patientDetailsData?.full_name,
        email: patientDetailsData?.email,
        mobile: patientDetailsData?.mobile,
        maritalStatus: patientDetailsData?.marital_status?.toLowerCase(),
        diet: patientDetailsData?.diet?.toLowerCase(),
        gender: patientDetailsData?.gender?.toLowerCase(),
        occupation: patientDetailsData?.occupation_id || null,
        age: patientDetailsData?.age,
        father_or_husband: patientDetailsData?.father_or_husband || null,
        address: patientDetailsData?.address,
        education: patientDetailsData?.education_id || null,
        city: +patientDetailsData?.city || null,
        pincode: patientDetailsData?.pincode,
        visitType: appointmentData?.visit_type,
        attendingDoctor: appointmentData?.doctor?.id,
        consultancyDoctor: appointmentData?.consultant?.id,
        comments: appointmentData?.comments,
        referrer:
          appointmentData?.referrer_id || patientDetailsData?.referrer_id,
        height: appointmentData?.height,
        weight: appointmentData?.weight,
        fever: appointmentData?.fever,
        bpSystolic: appointmentData?.bp_s,
        bpDiastolic: appointmentData?.bp_d,
        bmi: appointmentData?.bmi,
        specialist_plan_title: appointmentData?.specialist_plan_title,
        specialist_plan_amount: appointmentData?.specialist_plan_amount,
      });
      setDrConsultId(appointmentData?.consultant?.id);
      setErrors({});
    }
  }, [appointmentData, patientDetailsData]);

  useEffect(() => {
    if (
      appointmentData?.ready_investigations &&
      appointmentData?.ready_investigations?.length > 0
    ) {
      setInvestigations(appointmentData?.ready_investigations);
    } else {
      setInvestigations([]);
    }
    if (appointmentData?.id && patientDetailsData?.id) {
      checkHistorySummary(patientDetailsData?.id, appointmentData?.id);
      console.log(appointmentData, "appointmentData in patient info form");
    }
  }, [appointmentData]);

  const handleInvestigationChange = (event) => {
    let selectedInvestigation = event.target;
    // console.log(event.target)
    selectedInvestigation = {
      name: selectedInvestigation?.value?.name,
      id: selectedInvestigation?.value?.value,
    };
    // console.log(selectedInvestigation);
    if (selectedInvestigation !== "default") {
      setInvestigations((prevInvestigations = []) => {
        if (!prevInvestigations.includes(selectedInvestigation?.value?.value)) {
          return [...prevInvestigations, selectedInvestigation];
        }
        return prevInvestigations;
      });
    }
  };

  //handle delete investigations
  const handleDeleteInvestigation = async (investigationToDelete) => {
    const investigationFind = appointmentData?.ready_investigations?.filter(
      // if investigation exist in appointment state also then call remove api also along with locally
      (investigation) => investigation.name === investigationToDelete,
    );

    if (investigationFind?.length > 0) {
      try {
        const res = await removeInvestigation(
          appointmentData.id,
          investigationToDelete,
        );
        // console.log(investigationToDelete, "investigationToDelete");
        setInvestigations((prevInvestigations) =>
          prevInvestigations.filter(
            (investigation) => investigation.name !== investigationToDelete,
          ),
        );
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    } else {
      // if investigation not exist in appointment state  then  delete locally
      setInvestigations((prevInvestigations) =>
        prevInvestigations.filter(
          (investigation) => investigation.name !== investigationToDelete,
        ),
      );
    }
  };

  useEffect(() => {
    setCommonData((prev) => ({
      ...prev,
      investigations: investigations,
    }));
  }, [investigations, setCommonData]);

  // hooks to fetch data
  const { data: investigationList, isLoading: isLoadingInvestigation } =
    UseFetchInvestigationList(drConsultId);
  const { data: allOccupation } = UseFetchOptions("occupations");
  const { data: allCities } = UseFetchOptions("cities");
  const { data: allEducations } = UseFetchOptions("educations");
  const { data: drQuery } = UseFetchDoctorList();
  const { data: visitTypes } = UseFetchVisitType();
  const { data: referDr, refetch: refetchReferrer } = UseFetchReferDoctor();
  //  console.log(investigationList?.payload?.investigations)

  const handleKeyDown = (e, field) => {
    if (e.key === "Tab" && field === "fullName") {
      if (currentStep === 0 && isOpen) {
        setCurrentStep(1);
      }
    }
    if (e.key === "Tab" && field === "email") {
      if (currentStep === 1 && isOpen) {
        setTimeout(() => {
          document.getElementById(`diagnosis`).focus();
        }, 0);
        setCurrentStep(2);
      }
    }
  };

  // console.log(currentStep)

  const handleInputChange = (event, value, name) => {
    //  console.log("Event:", event, "Value:", value, "Name:", name);
    let fieldName;

    if (event) {
      const { name: eventName, value: eventValue } = event.target;
      fieldName = event.target.name;

      if (
        (fieldName === "age" && eventValue?.length > 3) ||
        (fieldName === "mobile" && eventValue?.length > 10)
      ) {
        return;
      }

      if (fieldName === "consultancyDoctor") {
        if (drConsultId !== eventValue) {
          setDrConsultId(eventValue);
          setInvestigations(appointmentData?.ready_investigations || []);
        }
        setFormState((prevState) => ({
          ...prevState,
          [eventName]: eventValue,
        }));
      }

      setFormState((prevState) => ({
        ...prevState,
        [eventName]: eventValue,
      }));
    } else if (name) {
      fieldName = name;
      if (value?.value === "other") {
        setFormState((prev) => ({ ...prev, [name]: true }));
      } else if (name === "referrer") {
        setFormState((prevState) => ({
          ...prevState,
          [name]: value?.id || value,
        }));
        setDrReferrerDetail(value);
      } else {
        setFormState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  const handleOpenDialog = (name, currentValue) => {
    // console.log(name, currentValue, "name , currentValue");
    setOpenDialogs((prev) => ({ ...prev, [name]: true }));

    // Determine if currentValue is an integer
    if (Number.isInteger(currentValue)) {
      // If currentValue is an integer, find the corresponding option object
      const foundOption = fieldOptions[name]?.find(
        (option) => option.id === currentValue,
      );
      // Set dialog input to the title of the found option, or fallback to currentValue
      setDialogInput(foundOption ? foundOption : currentValue);
      setEditingOption(foundOption ? foundOption : currentValue || "");
    } else {
      // If currentValue is not an integer (likely an object), directly set it
      setDialogInput(currentValue || "");
      setEditingOption(currentValue || "");
    }
  };

  const handleCloseDialog = (name) => {
    setOpenDialogs((prev) => ({ ...prev, [name]: false }));
    setDialogInput("");
    setEditingOption(null);
  };

  const handleDialogInputChange = (event) => {
    setDialogInput(event.target.value);
  };

  // const handleAddOrEditValue = async (name) => {
  //   let updatedOptions = {};
  //   let index = null;

  //   if (dialogInput) {
  //     setFieldOptions((prevOptions) => {
  //       updatedOptions = [...prevOptions[name]];

  //       if (editingOption) {
  //         index = updatedOptions.findIndex(
  //           (option) => option.id === editingOption.id
  //         );
  //         console.log(index, "index filed");
  //         if (index !== -1) {
  //           updatedOptions[index].value = dialogInput;
  //           updatedOptions[index].title = dialogInput;
  //         }
  //       } else {
  //         updatedOptions.push({
  //           title: dialogInput,
  //           value: dialogInput,
  //           id: Math.random(),
  //         });
  //         index = updatedOptions.length - 1;
  //       }
  //       return { ...prevOptions, [name]: updatedOptions };
  //     });
  //     // console.log(updatedOptions[index], editingOption.id, "updatedOptions");

  //     if (editingOption) {
  //       const result = await updateMasterData(name, updatedOptions[index]?.id, {
  //         value: updatedOptions[index].value,
  //       });
  //       showToast(`${name} updated successfully`, "SUCCESS");
  //       console.log(result);
  //     } else {
  //       const result = await addOptionInAppointForm(
  //         { value: updatedOptions[index].value },
  //         name
  //       );
  //       showToast(`${name} added successfully`, "SUCCESS");
  //       // console.log(result);
  //     }
  //     setFormState((prevState) => ({
  //       ...prevState,
  //       [name]: updatedOptions[index],
  //     }));

  //     handleCloseDialog(name);
  //   }
  // };

  const handleAddOrEditValue = async (name) => {
    let updatedOptions = {};
    // let index = null;
    if (dialogInput) {
      let result;
      if (editingOption) {
        result = await updateMasterData(name, editingOption.id, {
          value: dialogInput,
        });
        showToast(`${name} updated successfully`, "SUCCESS");
        setFieldOptions((prevOptions) => {
          const updatedOptions = [...prevOptions[name]].map((option) => {
            if (option.id === result?.payload?.id) {
              return {
                ...option,
                title: result?.payload?.title || result?.payload?.name,
                value: result?.payload?.value || result?.payload?.name,
                id: result?.payload?.id,
              };
            }
            return option;
          });
          return {
            ...prevOptions,
            [name]: updatedOptions,
          };
        });
      } else {
        result = await addOptionInAppointForm({ value: dialogInput }, name);
        showToast(`${name} added successfully`, "SUCCESS");
        setFieldOptions((prevOptions) => {
          updatedOptions = [...prevOptions[name]];
          updatedOptions.push({
            title: result?.payload?.title || result?.payload?.name,
            value: result?.payload?.value || result?.payload?.name,
            id: result?.payload?.id,
          });
          // index = updatedOptions?.length - 1;
          return { ...prevOptions, [name]: updatedOptions };
        });
      }
      setFormState((prevState) => ({
        ...prevState,
        [name]: result?.payload?.id,
      }));
      handleCloseDialog(name);
    }
  };

  // console.log(formState, 'formState')
  // console.log(fieldOptions, 'fieldOptions')

  const handleAddOrEditValueRef = (name, referrer) => {
    // console.log(name, referrer);
    const newReferrer = {
      id: referrer?.id,
      title: `${referrer?.full_name || ""} - ${referrer?.address || ""} - ${
        referrer?.phone || ""
      }`,
      value: referrer?.full_name || "",
      address: referrer?.address || "",
      email: referrer?.email || "",
      phone: referrer?.phone || "",
    };

    setFieldOptions((prev) => ({
      ...prev,
      referrer: [...(prev.referrer || []), newReferrer],
    }));

    setTimeout(() => {
      setFormState((prevState) => ({
        ...prevState,
        [name]: referrer?.id,
      }));
      refetchReferrer();
    }, 100);
  };

  /// set field option
  useEffect(() => {
    const initialOptions = {};
    allFormFields.forEach((field) => {
      if (field?.field === "Autocomplete") {
        initialOptions[field?.name] = field?.options;
      }
    });
    setFieldOptions(initialOptions);
  }, []);
  // set education occupation and cities option in fields

  useEffect(() => {
    const newReferDr = referDr?.payload?.referrers?.map((refer) => ({
      id: refer?.id,
      title: `${refer?.full_name || ""}${
        refer?.profession ? ` [${refer?.profession}]` : ""
      }${refer?.qualification ? ` [${refer?.qualification}]` : ""}${
        refer?.city ? ` - ${refer?.city}` : ""
      }${refer?.phone ? ` - ${refer?.phone}` : ""}`,
      value: refer?.full_name,
      email: refer?.email,
      phone: refer?.phone,
      address: refer?.address,
    }));
    const newAllCities = allCities?.cities?.map((el) => ({
      id: el?.id,
      title: el?.name,
      value: el?.name,
    }));

    setFieldOptions((prev) => ({
      ...prev,
      occupation: allOccupation?.occupations,
      education: allEducations?.educations,
      city: newAllCities,
      referrer: newReferDr,
    }));
  }, [allCities, allEducations, allOccupation, referDr]);

  // set dr option
  useEffect(() => {
    const formattedDrList = drQuery?.doctors?.map((dr) => ({
      value: dr?.id,
      label: dr?.full_name,
      id: dr?.id,
    }));
    let newData = allFormFields?.map((field) => {
      if (
        field.name === "attendingDoctor" ||
        field.name === "consultancyDoctor"
      ) {
        return { ...field, options: formattedDrList };
      }
      return field;
    });
    dispatch(setDoctorOption(formattedDrList));

    setAllFormFields(newData);
  }, [drQuery]);

  useEffect(() => {
    if (visitTypes?.payload?.visit_types?.length > 0) {
      const formattedVisitTypes = visitTypes.payload.visit_types.map(
        (type) => ({
          value: type.toLowerCase(),
          label: type.charAt(0).toUpperCase() + type.slice(1).toLowerCase(),
        }),
      );
      setAllFormFields((prev) =>
        prev.map((field) =>
          field.name === "visitType"
            ? { ...field, options: formattedVisitTypes }
            : field,
        ),
      );
    }
  }, [visitTypes]);

  function cleanPayload(obj) {
    if (Array.isArray(obj)) {
      return obj.map(cleanPayload).filter((item) => item != null);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj)
          .map(([key, value]) => [key, cleanPayload(value)])
          .filter(([_, value]) => value != null && value !== ""),
      );
    }
    return obj;
  }

  // console.log( 'patientDetails from api ', patientDetailsData);
  // console.log( 'form state', formState);
  const validateForm = (formData) => {
    let newErrors = {};
    let isValid = true;

    PrescriptionForm.slice(1, 13).forEach((field) => {
      if (field.pattern) {
        const value = formData[field.name];
        if (!new RegExp(field.pattern).test(value)) {
          newErrors[field.name] = field.errorMessage || "Invalid input";
          isValid = false;
        }
      }
      // Add any other validation rules here
      if (field.required && !formData[field.name]) {
        // newErrors[field.name] = `${[field.name]}  is required`;
        newErrors[field.name] = field.errorMessage || "Invalid input";
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSavePatient = async () => {
    setButtonLoading(true);

    if (!validateForm(formState)) {
      setButtonLoading(false);
      return null;
    }

    try {
      let oldPatientData = {
        id: patientDetailsData?.id,
        uid: formState?.id,
        full_name: formState?.fullName,
        email: formState?.email,
        mobile: formState?.mobile,
        marital_status: formState?.maritalStatus,
        diet: formState?.diet,
        gender: formState?.gender,
        occupation_id:
          typeof formState?.occupation === "boolean"
            ? null
            : formState?.occupation?.id || formState?.occupation || null,
        age: formState?.age,
        address: formState?.address,
        education_id:
          typeof formState?.education === "boolean"
            ? null
            : formState?.education?.id || formState?.education || null,
        city:
          typeof formState?.city === "boolean"
            ? null
            : formState?.city?.id || formState?.city || null,
        pincode: formState?.pincode,
        father_or_husband: formState?.father_or_husband || null,
      };

      oldPatientData = cleanPayload(oldPatientData);
      if (patientDetailsData?.id) {
        let result = await saveOldPatientAppointment(
          oldPatientData,
          patientDetailsData?.id,
        );
        showToast(
          "Patient details updated",
          result?.status?.message || result?.status?.status,
          result?.status?.status,
        );
        // console.log(result, "result of update");
        setButtonLoading(false);
      } else {
        let createData = {
          patient: {
            full_name: formState?.fullName,
            email: formState?.email,
            mobile: formState.mobile,
            marital_status: formState?.maritalStatus?.toLowerCase(),
            diet: formState?.diet?.split("-")?.join("_")?.toLowerCase(),
            gender: formState?.gender?.toLowerCase(),
            occupation_id:
              typeof formState?.occupation === "boolean"
                ? null
                : formState?.occupation?.id || formState?.occupation || null,

            age: formState?.age,
            address: formState?.address,
            education_id:
              typeof formState?.education === "boolean"
                ? null
                : formState?.education?.id || formState?.education || null,
            city:
              typeof formState?.city === "boolean"
                ? null
                : formState?.city?.id || formState?.city || null,
            pincode: formState?.pincode,
            father_or_husband: formState?.father_or_husband || null,
          },
        };

        createData = cleanPayload(createData);
        let createdPatient = await createPatient(createData);
        if (createdPatient?.status?.status === "SUCCESS") {
          dispatch(setPatientDetailsData(createdPatient?.payload));
        }
        const statusMessage = createdPatient?.status?.status || "ERROR";
        const detailedMessage =
          createdPatient?.status?.message || "Something went wrong";
        showToast(statusMessage, detailedMessage);
        showToast(
          createdPatient?.status?.message || createdPatient?.status?.status,
          createdPatient?.status?.status,
        );
        // console.log(createdPatient, "result of create patient");
        setButtonLoading(false);
      }
    } catch (error) {
      console.log(error);
      setButtonLoading(false);
    }
  };

  //referrer email
  useEffect(() => {
    const fetchMailTemplate = async () => {
      try {
        if (drReferrerDetail?.id && patientDetailsData?.id) {
          let res = await getMailTemplate(
            drReferrerDetail?.id,
            patientDetailsData?.id,
          );
          setMailTemplate(res);
        }
      } catch (error) {
        console.error("Error fetching mail template:", error);
      }
    };
    fetchMailTemplate();
  }, [drReferrerDetail, patientDetailsData]);

  useEffect(() => {
    setCommonData((prev) => ({
      ...prev,
      patientForm: formState,
    }));
  }, [formState, setCommonData]);

  const { patientData } = useSelector((state) => state.prescription);

  // search query for patient by name or id
  const debouncedInputValue = useDebounce(inputValue, 1000);

  useEffect(() => {
    if (debouncedInputValue) {
      setSearchData((prev) => ({ ...prev, q: debouncedInputValue }));
    } else {
      dispatch(setSearchPatient([]));
    }
  }, [debouncedInputValue, dispatch]);

  // change input for search
  const { data: searchResult, isLoading: isSearchingPatient } =
    UseSearchPatient(searchData);
  const { data: patientDetailsQuery, isLoading: patientDetailsLoading } =
    UsePatientDetail(patientId);
  const { data: appointmentDetails, isLoading: appointmentDataLoading } =
    UseFetchAppointmentDetailsPatient(appointmentId);
  const {
    data: prescriptionData,
    isLoading: prescriptionDataLoading,
    status: prescriptionStatus,
  } = UsePatientDetailPrescription(prescriptionId);
  // const { data: consultationSummary, isLoading: consultationSummaryLoading } =
  //   UseFetchAiSummaryS3(
  //     "consultation_summary",
  //     appointmentData?.id,
  //     "Appointment",
  //   );

  const checkHistorySummary = async (patientId, appointmentId) => {
    if (!patientId || !appointmentId) return;
    try {
      const res = await getPatientAiSummary(
        patientId,
        appointmentId,
        "Appointment",
        "octabot",
      );
      const summary = res?.payload?.summary;

      if (summary && Object.keys(summary)?.length > 0) {
        setPatientAiSummaryData(res.payload.summary);
        setOpenHistoryModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChangeSearch = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  useEffect(() => {
    if (searchResult?.payload?.patients) {
      dispatch(setSearchPatient(searchResult?.payload?.patients));
    }
  }, [searchResult, dispatch, inputValue]);

  useEffect(() => {
    if (patientDetailsQuery?.payload) {
      dispatch(setPatientDetailsData(patientDetailsQuery?.payload)); // Dispatch patient details to store
    }

    if (patientDetailsQuery?.payload?.appointments) {
      const dates = patientDetailsQuery?.payload?.appointments
        ?.filter(
          (appointment) =>
            ["completed", "paid"].includes(appointment.status) ||
            appointment?.prescription_id,
        )
        .map((appointment) => ({
          date: dayjs(appointment.visit_date).tz("Asia/Kolkata").format("ddd MMM DD YYYY"),
          id: appointment?.id, // Track the appointment ID for fetching details
          prescription_id: appointment?.prescription_id,
          appointmentStatus: appointment?.status,
        }));
      setAppointmentsDate(dates);
      const latestAppt = patientDetailsQuery.payload.appointments[0];
      if (latestAppt?.id && patientDetailsQuery.payload.id) {
        checkHistorySummary(patientDetailsQuery?.payload?.id, latestAppt?.id);
      }
    } else {
      setAppointmentsDate([]);
    }
  }, [patientDetailsQuery, dispatch]);

  // console.log(appointmentsDate)

  useEffect(() => {
    if (appointmentDetails) {
      dispatch(setAppointmentData(appointmentDetails)); // Dispatch patient  appointment data to Redux store
    }
  }, [appointmentDetails, dispatch]);

  // Set the appointment ID after fetching patient details
  useEffect(() => {
    if (
      patientDetailsQuery?.payload?.appointments?.length > 0 &&
      appointmentsDate?.length > 0
    ) {
      setAppointmentId(appointmentsDate[0]?.id); // Assuming you need the first appointment ID
    }
  }, [patientDetailsQuery, appointmentsDate]);

  // console.log(appointmentsDate[0]?.id , 'appt id');

  // console.log(appointmentDetails?.prescription?.id, 'prec id')
  // Set the prescription ID after fetching appointment details
  useEffect(() => {
    if (appointmentDetails?.patient?.appointments?.length > 0) {
      // setPrescriptionId(
      //   appointmentDetails?.patient?.appointments[0]?.prescription_id
      // );
      // Assuming you need the first prescription ID
      setPrescriptionId(
        (appointmentDetails?.prescription?.id &&
          appointmentDetails?.prescription?.id) ||
          (appointmentsDate?.length >= 2 &&
            appointmentsDate[1]?.prescription_id),
      );
    }
  }, [appointmentDetails]);

  // console.log(appointmentsDate , 'appointmentsDate patient  details')
  // Dispatch prescription data to Redux store
  useEffect(() => {
    if (prescriptionData && prescriptionStatus === "success") {
      dispatch(setPrescriptionData(prescriptionData));
      // console.log("prescriptionData form ");
    }
  }, [prescriptionData, dispatch]);

  const selectedPatient = (id) => {
    dispatch(setPatientDetailsData({})); // remove previous patient data
    dispatch(setAppointmentData({}));
    dispatch(setPrescriptionData([]));
    setCommonData({
      patientForm: {},
      treatmentDetail: {},
      investigations: [],
      medicines: [],
    });

    setTimeout(() => {
      setPatientId(id?.id);
    }, 0);
  };

  const [allDataLoading, setAllDataLoading] = useState(false);
  // Debounce effect to stabilize allDataLoading state
  useEffect(() => {
    if (patientDetailsLoading) {
      // console.log(patientDetailsLoading);
      setAllDataLoading(true); // Set to true immediately when patientDetailsLoading starts
    } else if (
      !patientDetailsLoading &&
      !appointmentDataLoading &&
      !prescriptionDataLoading
    ) {
      // Use a timeout to debounce the false state change
      const timer = setTimeout(() => {
        setAllDataLoading(false);
        // console.log("i am loader", "all api loader");
      }, 1000);

      return () => clearTimeout(timer); // Clear timeout if dependencies change before debounce ends
    }
  }, [patientDetailsLoading, appointmentDataLoading, prescriptionDataLoading]);

  // Console log to observe state changes dddd

  // console.log(formState)
  // console.log(
  //   `${allDataLoading} all api loader`,
  //   `${patientDetailsLoading} api 1`,
  //   `${appointmentDataLoading} api 2`,
  //   `${prescriptionDataLoading} api 3`
  // );

  // console.log(investigations, 'investigations')
  // useEffect(() => {
  //   const fetchPrescription = async () => {
  //     if (!appointmentDetails?.prescription_id) {
  //       if (
  //         patientDetailsData?.appointments?.length > 1 &&
  //         !patientDetailsData?.appointments[0]?.prescription_id
  //       ) {
  //         let prescriptionTruthyId = null;

  //         for (let appointment of patientDetailsData?.appointments) {
  //           if (appointment.prescription_id) {
  //             prescriptionTruthyId = appointment.prescription_id;
  //             break; // Stop at the first truthy prescription_id
  //           }
  //         }
  //         if (prescriptionTruthyId) {
  //           try {
  //             const res = await getPatientPrescription(prescriptionTruthyId);
  //             // console.log(res, "Fetched Prescription Data TO save medicine from an prev prescription");

  //             if (res) {
  //               dispatch(setPrescriptionData(res));
  //             }
  //           } catch (error) {
  //             console.error("Error fetching prescription:", error);
  //           }
  //         } else {
  //           console.warn("No truthy prescription ID found in appointments");
  //         }
  //       }
  //     }(
  //   };
  //   fetchPrescription();
  // }, [appointmentDetails]);

  // console.log(investigations, 'investigations')

  // useEffect(() => {
  //   if (!investigationList?.payload?.medical_tests) return;

  //   // Extract the list of ready investigations' IDs
  //   const readyInvestigationIds = new Set(investigations.map(inv => inv.id));

  //   // Filter only new investigations that are not in readyInvestigations
  //   const defaultInv = investigationList.payload.medical_tests.filter(
  //     (item) => item.isinvestigation && !readyInvestigationIds.has(item.id)
  //   );

  //   // Update the state with missing investigations
  //   setInvestigations((prev) => [...prev, ...defaultInv]);

  //   console.log(defaultInv, 'defaultInv');
  // }, [investigationList]);
  // Effect runs when investigationList or readyInvestigations update

  useEffect(() => {
    if (!investigationList?.payload?.medical_tests) return;
    if (appointmentData?.ready_investigations) {
      return;
    } else {
      const defaultInv = investigationList.payload.medical_tests.filter(
        (item) => item.isinvestigation,
      );
      setInvestigations((prev) => [...prev, ...defaultInv]);
      // console.log(defaultInv, 'defaultInv');
    }
  }, [investigationList, appointmentData]);

  // const getTourClassName = (fieldName, tourFocus) => {
  //   const tourMapping = {
  //     fullName: 0,
  //     email: 1,
  //     mobile: 2,
  //   };

  //   if (tourMapping[fieldName] !== undefined) {
  //     const focus = tourMapping[fieldName];
  //     if (Array.isArray(focus)) {
  //       return focus.includes(tourFocus) ? "step-one" : "";
  //     }
  //     return focus === tourFocus ? "step-one" : "";
  //   }

  //   return "";
  // };

  const renderField = (field) => {
    let maxLength;
    if (field.name === "mobile") {
      maxLength = 10;
    }
    switch (field.field) {
      case "TextField":
        return (
          <TextField
            fullWidth
            type={field.type}
            // {field.name=="id"?  s}
            disabled={field.isDisabled}
            placeholder={field.placeholder}
            sx={{
              ...field.sx,
              cursor: field.name === "id" ? "not-allowed" : "auto",
            }}
            className={
              (field.name === "fullName" && "step-one") ||
              (field.name === "email" && "step-two")
            }
            onKeyDown={(e) => handleKeyDown(e, field?.name)}
            id={field.name === "fullName" && "fullName"}
            variant={field.variant}
            name={field.name}
            value={formState[field.name] || ""}
            onChange={handleInputChange}
            error={Boolean(errors[field.name])}
            helperText={errors[field.name] || ""}
            inputProps={{
              ...(field.type === "date"
                ? { max: dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD") }
                : {}),
              ...(field.name === "mobile" ? { maxLength: maxLength } : {}),
            }}
          />
        );
      case "Select":
        if (field.name === "investigationType") {
          // const { data: investigationList, isLoadingInvestigation } = UseGetInvestigationList(drConsultId);
          //  console.log(investigationList?.payload?.investigations?.extras ,'investigation')
          // Transform the fetched data to match the expected structure
          // const options =
          //   investigationList?.payload?.investigations?.extras.map((item) => ({
          //     value: item?.name.toUpperCase(),
          //     label: item?.name.toUpperCase(),
          //   })) || [];

          const options =
            investigationList?.payload?.medical_tests
              ?.filter(
                (item) => !investigations?.some((inv) => inv?.id === item?.id),
              )
              ?.map((item) => ({
                value: item?.id,
                name: item?.name,
                label: item?.code,
              })) || [];

          // console.log(options)
          return (
            <FormControl fullWidth variant="outlined">
              <Select
                fullWidth
                sx={{
                  ...field.sx,
                  color: formState[field.name]
                    ? "text.black"
                    : "text.default_grey",
                }}
                onChange={(event) => {
                  handleInvestigationChange(event);
                }}
                value={formState[field.name] || ""}
                name={field.name}
                displayEmpty
                required={true}
              >
                <MenuItem value="" disabled>
                  <span>{field.placeholder || "Select investigation"}</span>
                </MenuItem>

                {/* Render options dynamically from fetched API */}
                {options.map((option) => (
                  <MenuItem
                    id={option.value || "menu"}
                    key={option.value + Math.random()}
                    value={option}
                    // sx={{
                    //   ...(option.value === field.defaultValue
                    //     ? field.defaultMenuStyle
                    //     : field.menuItemStyle),
                    // }}
                    sx={menuItemStyle}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
              {field.name === "investigationType" && isLoadingInvestigation && (
                <InputAdornment
                  position="end"
                  sx={{ marginLeft: "200px", marginTop: "-20px" }}
                >
                  <CircularProgress size={20} />
                </InputAdornment>
              )}

              {/* Display errors if any */}
              {errors[field.name] && (
                <Typography fontSize={"12px"} color={"neutral.red"}>
                  {errors[field.name]}
                </Typography>
              )}
            </FormControl>
          );
        } else
          return (
            <FormControl fullWidth variant="outlined">
              <Select
                fullWidth
                sx={{
                  ...field.sx,
                  color: formState[field.name]
                    ? "text.black"
                    : "text.default_grey",
                }}
                onChange={(event) => {
                  handleInputChange(event);
                }}
                value={formState[field.name] || ""}
                //onChange={handleFormChange}

                name={field.name}
                displayEmpty
                required={true}
              >
                <MenuItem value="" disabled>
                  <span>{field?.placeholder || "Select an option"}</span>
                </MenuItem>

                {field?.options?.map((option) => (
                  <MenuItem
                    id={option?.value || "menu"}
                    key={option.value + Math.random()}
                    value={option.value}
                    sx={{
                      ...(option.value === field.defaultValue
                        ? field.defaultMenuStyle
                        : field.menuItemStyle),
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>

              {errors[field.name] && (
                <Typography fontSize={"12px"} color={"#d32f2f"}>
                  {errors[field.name]}
                </Typography>
              )}
            </FormControl>
          );
      case "Autocomplete":
        return (
          <>
            <Autocomplete
              clearIcon={false}
              popupIcon={false}
              options={[
                ...(fieldOptions[field?.name] || field?.options),
                { id: "other", value: "other", title: "Other" },
              ]}
              // options={
              //   field.name === "investigationType"
              //   ? (fieldOptions[field.name] || field?.options)?.filter((option) => {
              //     console.log(option?.title , 'hello'); // This logs the title for debugging.
              //     return !investigations
              //       ?.map((inv) => inv.name.toLowerCase())
              //       ?.includes(option?.title?.toLowerCase()); // Ensure case-insensitive comparison.
              //   })
              // : [
              //     ...(fieldOptions[field.name] || field.options),
              //     { id: "other", value: "other", title: "Other" },
              //   ]
              // }
              sx={{
                "& .MuiAutocomplete-listbox": {
                  width: "400px !important",
                },
              }}
              value={
                (formState[field?.name] &&
                  (fieldOptions[field?.name] || field?.options)?.find(
                    (option) =>
                      option?.value ===
                        (formState[field?.name]?.value ||
                          formState[field?.name]) ||
                      option?.title ===
                        (formState[field?.name]?.title ||
                          formState[field?.name]) ||
                      option?.id === formState[field?.name],
                  )) ||
                null
              }
              onChange={(event, newValue) =>
                handleInputChange(null, newValue, field.name)
              }
              // PopperComponent={(props) => (
              //   <Grid item lg={8}>
              //     <Popper
              //       {...props}
              //       sx={{ width: "fit-content" }}
              //       placement="bottom-start"
              //       style={menuItemStyle}
              //     />
              //   </Grid>
              // )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={field.placeholder}
                  variant={field.variant}
                  fullWidth
                  sx={field.sx}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        <IconButton
                          onClick={() =>
                            handleOpenDialog(field.name, formState[field.name])
                          }
                        >
                          <EditNoteIcon />
                        </IconButton>
                      </>
                    ),
                  }}
                />
              )}
              getOptionLabel={(option) =>
                option.title && option.value ? `${option.title}` : ""
              }
              renderOption={(props, option, { index }) => (
                <MenuItem
                  sx={{
                    ...menuItemStyle,
                    // "&:hover": {
                    //   backgroundColor: "#0067FF40 !important",
                    //   borderRadius: "16px",
                    //   color: "black !important",
                    // },
                    // ...(index === 0 && {
                    //   backgroundColor: "#0067FF40 !important",
                    //   color: "black !important",
                    //   borderRadius: "16px",
                    // }),
                  }}
                  {...props}
                  key={option?.id + Math.random()}
                >
                  {option?.title}
                </MenuItem>
              )}
            />
            <Dialog
              open={openDialogs[field.name] || false}
              onClose={() => handleCloseDialog(field?.name)}
              PaperProps={{
                sx: {
                  marginTop: "60",
                  top: "0",
                  position: "absolute",
                  width: "23%",
                  maxWidth: "none",
                  borderRadius: "20px",
                },
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <DialogTitle>
                  {/* {editingOption ? `Update/Create` : "Update / Create"}{" "}
                {field.name} */}

                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    {field.name === "city" && (
                      <LocationCityIcon
                        sx={{
                          color: "neutral.navyBlue",
                          height: "30px",
                          width: "30px",
                        }}
                      />
                    )}
                    {field.name === "occupation" && (
                      <WorkOutlineOutlinedIcon
                        sx={{
                          color: "neutral.navyBlue",
                          height: "30px",
                          width: "28px",
                        }}
                      />
                    )}
                    {field.name === "education" && (
                      <SchoolIcon
                        sx={{
                          color: "neutral.navyBlue",
                          height: "30px",
                          width: "28px",
                        }}
                      />
                    )}

                    <Typography variant="heading1">
                      {" "}
                      {editingOption ? `Update/Create` : "Update / Create"}{" "}
                      {field?.name}
                    </Typography>
                  </Box>
                </DialogTitle>

                <Button onClick={() => handleCloseDialog(field.name)}>
                  <CloseIcon
                    sx={{ color: "red", height: "20px" }}
                    size="small"
                    color="red"
                  />
                </Button>
              </Box>

              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  value={
                    typeof dialogInput === "string"
                      ? dialogInput
                      : dialogInput?.title ||
                        (formState[field.name] &&
                          (fieldOptions[field.name] || field.options)?.find(
                            (option) =>
                              [option.value, option.title, option.id].includes(
                                formState[field.name]?.value ||
                                  formState[field.name]?.title ||
                                  formState[field.name],
                              ),
                          )?.title) ||
                        ""
                  }
                  placeholder="Edit option"
                  onChange={handleDialogInputChange}
                  InputProps={{
                    sx: {
                      height: "42px",
                      padding: "12px",
                      borderRadius: "20px",
                      "& .MuiInputBase-input": {
                        height: "15px",
                        padding: "0px",
                        boxSizing: "border-box",
                      },
                    },
                  }}
                />
                <Button
                  onClick={() => handleAddOrEditValue(field.name)}
                  sx={{
                    ...primaryBtnTeal,
                    marginTop: "8px",
                    float: "right",
                    p: 2.3,
                    color: "white",
                  }}
                >
                  {editingOption ? "Save" : "Save"}
                </Button>
              </DialogContent>

              <DialogActions></DialogActions>
            </Dialog>

            {errors[field.name] && (
              <Typography fontSize={"12px"} color={"#d32f2f"}>
                {errors[field?.name]}
              </Typography>
            )}
          </>
        );
      case "Autocomplete1":
        return (
          <>
            {/* {console.log(formState[field.name])} */}
            <Autocomplete
              options={fieldOptions[field?.name] || field?.options}
              clearIcon={false}
              popupIcon={false}
              getOptionLabel={(option) =>
                option?.title && option?.value ? `${option?.title}` : ""
              }
              // value={formState[field.name] || ""}
              // value={
              //   (formState[field.name] &&
              //     (fieldOptions[field.name] || field.options)?.find(
              //       (option) =>
              //         option.value ===
              //         (formState[field.name]?.value ||
              //           formState[field.name]) ||
              //         option.title ===
              //         (formState[field.name]?.title ||
              //           formState[field.name]) ||
              //         option.id === formState[field.name]
              //     )) ||
              //   formState[field.name]
              // }
              value={
                (formState[field?.name] &&
                  (
                    fieldOptions[field?.name] ||
                    fieldOptions?.referrer ||
                    []
                  )?.find((option) => option?.id === formState[field?.name])) ||
                null
              }
              onChange={(event, newValue) =>
                handleInputChange(null, newValue, field.name)
              }
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  sx={{
                    maxHeight: "578.51px",
                    overflowY: "auto",
                    minWidth: "400px",
                    zIndex: 1300,
                  }}
                  placement="bottom-start"
                />
              )}
              renderOption={(props, option, { index }) => (
                <MenuItem
                  {...props}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    // "&:hover": {
                    //   backgroundColor: "#0067FF40 !important",
                    //   color: "white !important",
                    //   borderRadius:'16px',
                    // },
                    ...menuItemStyle,
                    // "&:hover": {
                    //   backgroundColor: "#0067FF40 !important",
                    //   borderRadius: "16px",
                    //   color: "black !important",
                    // },
                    // ...(index === 0 && {
                    //   backgroundColor: "#0067FF40 !important",
                    //   color: "black !important",
                    //   borderRadius: "16px",
                    // }),
                  }}
                >
                  {option.title}
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={field.placeholder}
                  variant={field.variant}
                  fullWidth
                  sx={{ ...field.sx }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params?.InputProps?.endAdornment}
                        <IconButton onClick={() => handleRefModal(true)}>
                          <EditNoteIcon />
                        </IconButton>
                      </>
                    ),
                  }}
                />
              )}
            />

            <CustomModal
              open={openRefModal}
              onClose={() => setRefModal(false)}
              // title="Referrer"
              // isTitle={true}
              customStyles={{ border: "none", minWidth: "50%" }}
            >
              <Referrer
                // selectedReferrer={formState["referrer"]}
                //  {...console.log(fieldOptions.referrer, "field option")}
                selectedReferrer={
                  (formState[field.name] &&
                    (fieldOptions.referrer || fieldOptions[field.name])?.find(
                      (option) =>
                        option.value === formState[field.name]?.value ||
                        option.id === formState[field.name],
                    )) ||
                  formState[field.name]
                }
                // selectedReferrer={
                //   formState[field.name] &&
                //   (fieldOptions[field.name] || fieldOptions.referrer)?.find(
                //     (option) =>
                //       option.value === formState[field.name]?.value ||
                //       option.id === formState[field.name]?.id
                //   ) || formState[field.name] // Fallback to formState[field.name] if no match is found
                // }

                setOpenModal={setRefModal}
                onSave={handleAddOrEditValueRef}
              />
            </CustomModal>
          </>
        );
      case "Button":
        return (
          <Box display="flex" sx={{ width: "100%" }}>
            {field?.hasIcon ? (
              field?.icon === "EmailIcon" ? (
                <IconButton
                  sx={{
                    ...mailBtn,
                    flex: 1, // allow expansion
                    // minWidth: "40px",        // base size
                    maxWidth: "42px", // limit growth
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ForwardToInboxOutlinedIcon
                    onClick={handleReferrerEmail}
                    // sx={mailBtn}
                  />
                </IconButton>
              ) : field?.icon === "RecordsIcon" ? (
                <IconButton
                  sx={{
                    ...mailBtn,
                    flex: 1, // allow expansion
                    // minWidth: "40px",        // base size
                    maxWidth: "42px", // limit growth
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AccessTimeOutlinedIcon
                    onClick={handlePatientRecordsModal}
                    // sx={mailBtn}
                  />
                </IconButton>
              ) : (
                <IconButton
                  sx={{
                    ...mailBtn,
                    flex: 1, // allow expansion
                    // minWidth: "40px",        // base size
                    maxWidth: "42px", // limit growth
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ContentPasteGoOutlinedIcon
                    onClick={handlePreview}
                    // sx={mailBtn}
                  />
                </IconButton>
              )
            ) : (
              <Button
                disabled={buttonLoading}
                fullWidth
                variant={field.variant}
                sx={{
                  ...field.sx,
                  width: "100%",
                  display: "flex",

                  ...(field?.text === "Save Patient Info"
                    ? { whiteSpace: "nowrap", fontSize: "14px" }
                    : {}),
                }}
                onClick={() => {
                  if (field?.text === "Save Patient Info") {
                    handleSavePatient();
                  } else if (field?.text === "Reports") {
                    handlePreview();
                  } else {
                    console.log(formState);
                  }
                }}
              >
                {field.text}
              </Button>
            )}
          </Box>
        );
      case "Typography":
        return (
          <Typography
            sx={{
              ...field.sx,
              display: "block",
              marginLeft: "5px",
              marginTop: "25px",
              marginBottom: "6px",
            }}
            variant={field.variant}
          >
            {field?.title}

            {appointmentData?.specialist_plan_title && (
              <Typography variant="span" fontSize="16px" marginLeft={"12px"}>
                ({appointmentData?.specialist_plan_title} :{" "}
                {appointmentData?.specialist_plan_amount} )
              </Typography>
            )}
          </Typography>
        );
      default:
        return null;
    }
  };

  // console.log(investigations, 'investigation');
  // console.log(appointmentData?.ready_investigations, 'appt ready ')

  // const [audioURL, setAudioURL] = useState(null); // for local playback
  // const [loading, setLoading] = useState(false);

  // const handleAudioSubmit = async (audioBlob) => {
  //   setLoading(true);
  //   try {
  //     const url = URL.createObjectURL(audioBlob);
  //     setAudioURL(url);

  //     // Prepare FormData
  //     const formData = new FormData();
  //     formData.append("audio_file", audioBlob, "recording.wav");

  //     // Send to API
  //     const res = await uploadAudio(formData);
  //     // console.log(res, 'res');
  //     if (res?.status?.status === 'SUCCESS') {
  //       const payload = {
  //         audio_file: res?.payload?.audio_url,
  //       }
  //       try {
  //         const voiceNote = await generateNote(payload)
  //         if (voiceNote?.status?.status === 'SUCCESS') {
  //           const outputString = voiceNote?.payload?.output;  // JSON as string
  //           const parsedOutput = JSON.parse(outputString);    // ✅ Convert to JS object
  //           console.log(parsedOutput, 'Parsed Output');
  //           // Example: extracting values
  //           const diagnosis = parsedOutput?.diagnosis || [];
  //           const specialInstructions = parsedOutput?.special_instructions || [];
  //           const notes = parsedOutput?.notes || [];
  //           const medicine = parsedOutput?.medicines || [];
  //           console.log(diagnosis, 'diagnosis');
  //           console.log(notes, 'notes');
  //           console.log(specialInstructions, 'specialInstructions');
  //           console.log(specialInstructions, 'specialInstructions');
  //           console.log(medicine, 'medicine');

  //         }
  //       } catch (error) {
  //         console.log(error)
  //       }
  //     }

  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const [expanded, setExpanded] = React.useState(true);
  // const [expandedVisit, setExpandedVisit] = React.useState(true);
  const [expandedPatient, setExpandedPatient] = useState(false);
  const [expandedVisit, setExpandedVisit] = useState(false);

  useEffect(() => {
    if (isOpen) {
      console.log(isOpen, "isOpen");
      setExpandedPatient(true);
    }
    const errorKeys = Object.keys(errors || {}).filter((key) => errors[key]);
    if (!errorKeys.length) return;

    setExpandedPatient(
      errorKeys.some((key) => ["fullName", "mobile", "age"].includes(key)),
    );

    setExpandedVisit(
      errorKeys.some((key) =>
        ["visitType", "attendingDoctor", "consultancyDoctor"].includes(key),
      ),
    );
  }, [errors, isOpen]);

  // console.log(isOpen, "isOpen");

  const handleAccordionChange = (event, isExpanded) => {
    setExpandedPatient(isExpanded);
  };

  const handleAccordionChangeVisit = (event, isExpanded) => {
    setExpandedVisit(isExpanded);
  };

  const collapsedSummary = [
    formState?.id,
    formState.fullName,
    formState.gender && `${formState?.gender}`,
    formState.age && `${formState?.age}y`,
    formState.mobile && `+91 ${formState?.mobile}`,
  ]
    .filter(Boolean)
    .join("   •   ");

  const collapsedSummaryVisit = [
    formState?.visitType
      ? formState.visitType[0]?.toUpperCase() + formState.visitType.slice(1)
      : "",
    formState?.specialist_plan_title && formState?.specialist_plan_amount
      ? `${formState.specialist_plan_title} ${formState.specialist_plan_amount}`
      : formState?.specialist_plan_title || formState?.specialist_plan_amount,
  ]
    .filter(Boolean)
    .join("   •   ");

  const hasVitals = allFormFields?.some(
    (field) =>
      field.id > 21 &&
      field.id < 31 &&
      formState[field.name] &&
      String(formState[field.name]).length > 0,
  );

  const validInvestigations = investigations?.filter(
    (inv) => inv?.before_value || inv?.after_value,
  );

  const MiniChip = ({ label, value, highlight }) => {
    if (!value) return null;

    return (
      <Box
        sx={{
          // backgroundColor: highlight ? "#009688" : "#ffffff",
          color: highlight ? "#fff" : "text.primary",
          borderRadius: "10px",
          // px: 1,
          // py: 1,
          gap: 0.4,
          minWidth: 40,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography fontSize={12} color={"#777777"}>
          {label}:{" "}
        </Typography>
        <Typography fontWeight={600}>{value}</Typography>
      </Box>
    );
  };

  const ResultMiniChip = ({ label, valueBefore, value, danger }) => (
    <Box
      sx={{
        // backgroundColor: "neutral.white",
        // borderRadius: "10px",
        // px: 1,
        // py: 1,
        minWidth: 30,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        gap: 0.4,
      }}
    >
      <Typography fontSize={12} color={"#777777"}>
        {label}:
      </Typography>
      <Typography fontWeight={600} color={danger ? "#D32F2F" : "text.primary"}>
        {value} {valueBefore && `(${valueBefore})`}
      </Typography>
    </Box>
  );

  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [patientAiSummaryData, setPatientAiSummaryData] = useState(null);

  // console.log(inputValue, 'inputValue')
  return (
    <>
      <Box
        sx={{
          backgroundColor: "neutral.prescriptionBackGround",
          border: "none !important",
          outline: "none !important",
          marginTop: "-20px",
          marginLeft: "-10px",
          padding: 2,
          pt: 5,
          // pb: 4,
        }}
      >
        {/* {search bar} */}
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <Autocomplete
              inputValue={inputValue}
              popupIcon={false}
              clearOnBlur={false}
              open={patientData?.length > 0 && openSearchDropDown}
              clearIcon={false}
              onOpen={() => setOpenSearchDropDown(true)}
              onClose={() => {
                dispatch(setSearchPatient([]));
                setOpenSearchDropDown(false);
              }}
              filterOptions={(options) => options}
              onChange={(event, newValue) => {
                if (newValue) {
                  selectedPatient(newValue);
                  setInputValue("");
                }
              }}
              onInputChange={handleInputChangeSearch}
              options={patientData || []}
              getOptionLabel={(option) =>
                option?.uid && option?.full_name
                  ? `${option?.uid} - ${option?.full_name}`
                  : ""
              }
              noOptionsText=""
              renderOption={(props, option) => (
                <MenuItem
                  key={option.id + Math.random()}
                  // onClick={() => selectedPatient(option)}
                  {...props}
                  sx={{
                    ...menuItemStyle,
                    width: "100%",
                    "&:hover, &.Mui-focused": {
                      backgroundColor: "neutral.backGround !important",
                      color: "black !important",
                    },
                  }}
                >
                  {" "}
                  {option?.uid
                    ? `${option?.uid} - ${option?.full_name}`
                    : option.full_name}
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  id="search"
                  inputValue={inputValue}
                  // value={inputValue}
                  value={inputValue}
                  placeholder="Search Patient"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isSearchingPatient ? (
                          <CircularProgress size={18} sx={{ mr: 1 }} />
                        ) : (
                          <SearchIcon sx={{ opacity: 0.4, mr: 1 }} />
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                  sx={{
                    ...textfieldTextPrep,
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* {patient details Accordion} */}
        <Accordion
          // defaultExpanded
          expanded={expandedPatient}
          onChange={handleAccordionChange}
          sx={{
            mt: 2,
            borderRadius: "10px",
            boxShadow: "none",
            border: "1px solid #E1E1E1",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "neutral.white",
              borderRadius: "16px",
              minHeight: "52px",
              // 🔥 main fix
              "& .MuiAccordionSummary-content": {
                alignItems: "flex-start",
                margin: "12px 0",
              },

              "& .MuiAccordionSummary-expandIconWrapper": {
                alignSelf: "flex-start",
                marginTop: "16px", // header ke center ke liye
              },
            }}
          >
            <Box sx={{ alignItems: "center", display: "flex", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: "neutral.blackBorder",
                  borderRadius: "50%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <PermIdentityOutlinedIcon sx={{ color: "#0097B2" }} />
              </Box>
              <Box>
                <Typography fontWeight={600}>Patient Demographics</Typography>
                {!expandedPatient && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "neutral.black",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {collapsedSummary}
                  </Typography>
                )}
              </Box>
            </Box>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={1}>
              {allFormFields.map((field) =>
                field.id <= 15 ? (
                  <Grid
                    item
                    key={field.id}
                    {...field.gridProps}
                    sx={{
                      display: field.position === "right" ? "flex" : "block",
                      justifyContent:
                        field.position === "right" ? "flex-end" : "flex-start",
                    }}
                  >
                    {renderField(field)}
                  </Grid>
                ) : null,
              )}
            </Grid>

            <Box
              mt={2}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  m: 0,
                  p: 0,
                  width: { xs: "100%", sm: "auto" },
                  alignItems: "center",
                }}
              >
                <Button
                  // id="createNewVisit"
                  onClick={handlePatientRecordsModal}
                  sx={{
                    ...primaryBtn,
                    // width: 'fit-content',
                    gap: 1,
                    whiteSpace: "nowrap",
                    // width: '110px'
                    width: { xs: "50%", sm: "auto" },
                  }}
                  disabled={buttonLoading}
                  // variant="contained"
                >
                  <HistoryOutlinedIcon sx={{ width: 22 }} />
                  Records
                </Button>

                <Button
                  // id="createNewVisit"
                  onClick={handlePreview}
                  sx={{
                    ...primaryBtn,
                    // width: 'fit-content',
                    gap: 1,
                    whiteSpace: "nowrap",
                    // width: '138px'
                    width: { xs: "50%", sm: "auto" },
                  }}
                  disabled={buttonLoading}
                  // variant="contained"
                >
                  <ContentPasteGoOutlinedIcon sx={{ width: 22 }} />
                  Test Reports
                </Button>
              </Box>

              <Button
                disabled={buttonLoading}
                fullWidth
                onClick={handleSavePatient}
                sx={{
                  ...primaryBtnTeal,
                  // width: "",
                  maxWidth: "160px",
                  display: "flex",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                }}
              >
                Save Patient Info
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* {patient Visit information Accordion} */}
        <Accordion
          expanded={expandedVisit}
          // defaultExpanded
          onChange={handleAccordionChangeVisit}
          sx={{
            mt: 2,
            borderRadius: "10px",
            boxShadow: "none",
            border: "1px solid #E1E1E1",
            overflow: "hidden", // 🔥 VERY IMPORTANT
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "neutral.white",
              borderRadius: "12px",
              minHeight: "56px",
              // alignItems: "flex-start",
              // alignItems: "center",
              // 🔥 main fix
              "& .MuiAccordionSummary-content": {
                alignItems: "flex-start",
                margin: "12px 0",
                marginBottom: "7px",
              },

              "& .MuiAccordionSummary-expandIconWrapper": {
                alignSelf: "flex-start",
                marginTop: "16px", // header ke center ke liye
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              {/* ================= HEADER ================= */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    backgroundColor: "neutral.blackBorder",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ErrorOutlineOutlinedIcon sx={{ color: "#0097B2" }} />
                </Box>

                <Box>
                  <Typography fontWeight={600}>Visit Information</Typography>
                  {!expandedPatient && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: "neutral.black",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {collapsedSummaryVisit}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* ================= CLOSED CONTENT ================= */}
              {!expandedVisit && (
                <Box
                  sx={{
                    mt: 1,
                    gap: 2,
                    display: expandedVisit ? "none" : "flex",
                  }}
                >
                  {/* ----------- VITALS ----------- */}
                  {hasVitals && (
                    <Box
                      sx={{
                        width: "50%",
                        backgroundColor: "#F9FCFD",
                        borderRadius: "14px",
                        border: "2px solid #E1E1E1",
                        p: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <TimelineOutlinedIcon
                          sx={{ color: "#0097B2", width: 16, height: 16 }}
                        />
                        <Typography color="#000000ff" fontSize={16}>
                          Vitals
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {allFormFields?.map((field) =>
                          field.id > 21 && field.id < 31 ? (
                            <MiniChip
                              label={field?.placeholder}
                              value={formState[field.name] || ""}
                            />
                          ) : null,
                        )}
                      </Box>
                    </Box>
                  )}

                  {/* ----------- TEST RESULTS ----------- */}
                  {validInvestigations?.length > 0 && (
                    <Box
                      sx={{
                        width: "50%",
                        backgroundColor: "#F9FCFD",
                        border: "2px solid #E1E1E1",
                        borderRadius: "14px",
                        p: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <DescriptionOutlinedIcon
                            sx={{ color: "#0097B2", width: 16, height: 16 }}
                          />
                          <Typography color="#000000ff" fontSize={16}>
                            Investigations
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {investigations?.slice(0, 6).map((investigation) => (
                          <ResultMiniChip
                            label={investigation?.name}
                            valueBefore={investigation?.before_value || ""}
                            value={investigation?.after_value || ""}
                            danger={investigation?.a === "danger"}
                          />
                        ))}
                        {investigations?.length > 4 && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              px: 1,
                              py: 0.5,
                              borderRadius: "20px",
                              backgroundColor: "#E8F4F8",
                              border: "1px solid #B0D8E5",
                              fontSize: 12,
                              color: "#0097B2",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                            }}
                          >
                            +{investigations.length - 4} more
                          </Box>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={1}>
              {/* {appointment details} */}
              {allFormFields?.map((field) =>
                field.id > 16 && field.id <= 21 ? (
                  <Grid
                    item
                    key={field.id}
                    {...field.gridProps}
                    sx={{
                      display: field.position === "right" ? "flex" : "block",
                      justifyContent:
                        field.position === "right" ? "flex-end" : "flex-start",
                    }}
                  >
                    {renderField(field)}
                  </Grid>
                ) : null,
              )}

              {/* {comment} */}
              {allFormFields?.map((field) =>
                field.id === 32 ? (
                  <Grid
                    item
                    key={field.id}
                    {...field.gridProps}
                    sx={{
                      display: field.position === "right" ? "flex" : "block",
                      justifyContent:
                        field.position === "right" ? "flex-end" : "flex-start",
                    }}
                  >
                    {renderField(field)}
                  </Grid>
                ) : null,
              )}

              {/* {Vitals} */}
              <Grid item mt={1} xs={12}>
                <Box
                  sx={{
                    border: "1px solid #E1E1E1",
                    padding: 1,
                    borderRadius: "14px",
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    {" "}
                    <TimelineOutlinedIcon
                      sx={{ color: "neutral.tealLight" }}
                    />{" "}
                    <Typography>Vitals Reading</Typography>
                  </Box>
                  <Grid container spacing={1} sx={{ width: "100%" }}>
                    {allFormFields?.map((field) =>
                      field.id > 21 && field.id < 32 ? (
                        <Grid
                          item
                          key={field.id}
                          {...field.gridProps}
                          sx={{
                            display:
                              field.position === "right" ? "flex" : "block",
                            justifyContent:
                              field.position === "right"
                                ? "flex-end"
                                : "flex-start",
                          }}
                        >
                          {renderField(field)}
                        </Grid>
                      ) : null,
                    )}
                  </Grid>
                </Box>
              </Grid>

              {investigations?.length > 0 && (
                <Grid item mt={1} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid #E1E1E1",
                      padding: 1,
                      borderRadius: "14px",
                    }}
                  >
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{ color: "neutral.tealLight" }}
                      />{" "}
                      <Typography>Investigations</Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {investigations?.map((investigation) => (
                        <Box
                          // item
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            minWidth: "175px",
                            maxWidth: "180px",
                            margin: "4px",
                          }}
                          // style={{ flexDirection: "column" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "2px",
                            }}
                          >
                            <CloseIcon
                              onClick={() =>
                                handleDeleteInvestigation(investigation.name)
                              }
                              sx={{
                                color: "red",
                                fontWeight: "800",
                                width: "20px",
                                marginRight: "2px",
                                cursor: "pointer",
                              }}
                            />

                            <Typography
                              variant="heading2_14"
                              fontWeight={"410"}
                              sx={{
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": {
                                  display: "none", // For Webkit browsers (Chrome, Safari): Hides the scrollbar
                                },
                              }}
                            >
                              {investigation?.name}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", gap: "5px" }}>
                            <Box>
                              <TextField
                                sx={{
                                  ...textfieldTextPrep,
                                  backgroundColor: "white",
                                  borderRadius: "15px",
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "white",
                                    cursor: "not-allowed",
                                    color:
                                      investigation?.before_color === "danger"
                                        ? "CypherMD_Text.tomato"
                                        : "",
                                  },
                                }}
                                disabled={true}
                                placeholder={`Before ${investigation?.name}`}
                                value={investigation?.before_value}
                              />
                              <Typography variant="body2_text">
                                {investigation?.before_date}
                              </Typography>
                            </Box>

                            <Box>
                              <TextField
                                sx={{
                                  ...textfieldTextPrep,
                                  backgroundColor: "white",
                                  borderRadius: "15px",
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "white",
                                    cursor: "not-allowed",
                                    color:
                                      investigation?.before_color === "danger"
                                        ? "CypherMD_Text.tomato"
                                        : "",
                                  },
                                }}
                                disabled={true}
                                placeholder={`After ${investigation?.name}`}
                                value={investigation?.after_value}
                              />
                              <Typography
                                variant="body2_text"
                                sx={{ textAlign: "center" }}
                              >
                                {investigation?.after_date}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Modal
        // open={true}
        open={allDataLoading}
        sx={{
          transition: "ease-in-out 1s",
          border: "none !important",
          outline: "none !important",
          position: "absolute",
          top: "40%",
          left: "40%",
        }}
      >
        <Box
          sx={{
            animation: `${rotateSpinner} 1s linear infinite`,
            width: "50px",
            border: "none !important",
            outline: "none !important",
          }}
        >
          <img
            src={loadingSpinner}
            alt=""
            style={{
              width: "50px",
              height: "50px",
              border: "none !important",
              outline: "none !important",
            }}
          />
        </Box>
      </Modal>

      <CustomModal open={openModal} onClose={() => setOpenModal(false)}>
        <PatientMedicalReports onClose={() => setOpenModal(false)} />
      </CustomModal>

      <CustomModal
        open={openReferrerEmail}
        onClose={() => setOpenReferrerEmail(false)}
      >
        <ReferrerEmail
          mailTemplate={mailTemplate}
          onClose={() => setOpenReferrerEmail(false)}
        />
      </CustomModal>

      <CustomModal
        open={patientRecordsModal}
        onClose={() => setPatientRecordsModal(false)}
      >
        <PatientRecords onClose={() => setPatientRecordsModal(false)} />
      </CustomModal>

      {/* Patient AI History Summary Modal */}
      <CustomModal
        open={openHistoryModal && !!patientAiSummaryData}
        onClose={() => setOpenHistoryModal(false)}
        customStyles={{ minWidth: "80%", p: 2.5 }}
      >
        <PatientHistorySummary
          summary={patientAiSummaryData}
          onClose={() => setOpenHistoryModal(false)}
          onContinue={() => setOpenHistoryModal(false)}
        />
      </CustomModal>
    </>
  );
};

export default PatientInfoForm;
